// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "mlmbox/types/scheme.proto" (package "mlmbox.types", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Pool_Hunter } from "./pool.ts";
import { Tree } from "./account.ts";
import { Tree_Group } from "./account.ts";
import { Wallet_Processing } from "./wallet.ts";
import { Wallet_Asset } from "./wallet.ts";
import { Locale } from "./locale.ts";
import { Exchanger_Rate } from "./exchanger.ts";
import { Asset } from "./asset.ts";
/**
 * @generated from protobuf message mlmbox.types.Scheme
 */
export interface Scheme {
    /**
     * @generated from protobuf field: repeated mlmbox.types.Asset assets = 1;
     */
    assets: Asset[];
    /**
     * @generated from protobuf field: repeated mlmbox.types.Exchanger.Rate asset_pair_exchange_rates = 2;
     */
    assetPairExchangeRates: Exchanger_Rate[];
    /**
     * @generated from protobuf field: repeated mlmbox.types.Locale locales = 3;
     */
    locales: Locale[];
    /**
     * @generated from protobuf field: repeated mlmbox.types.Wallet.Asset wallet_assets = 4;
     */
    walletAssets: Wallet_Asset[];
    /**
     * @generated from protobuf field: repeated mlmbox.types.Wallet.Processing wallet_processings = 5;
     */
    walletProcessings: Wallet_Processing[];
    /**
     * @generated from protobuf field: repeated mlmbox.types.Tree.Group tree_groups = 6;
     */
    treeGroups: Tree_Group[];
    /**
     * @generated from protobuf field: repeated mlmbox.types.Tree trees = 7;
     */
    trees: Tree[];
    /**
     * @generated from protobuf field: mlmbox.types.Pool.Hunter pool_hunter = 8;
     */
    poolHunter?: Pool_Hunter;
}
// @generated message type with reflection information, may provide speed optimized methods
class Scheme$Type extends MessageType<Scheme> {
    constructor() {
        super("mlmbox.types.Scheme", [
            { no: 1, name: "assets", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Asset },
            { no: 2, name: "asset_pair_exchange_rates", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Exchanger_Rate },
            { no: 3, name: "locales", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Locale },
            { no: 4, name: "wallet_assets", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Wallet_Asset },
            { no: 5, name: "wallet_processings", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Wallet_Processing },
            { no: 6, name: "tree_groups", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Tree_Group },
            { no: 7, name: "trees", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Tree },
            { no: 8, name: "pool_hunter", kind: "message", T: () => Pool_Hunter }
        ]);
    }
    create(value?: PartialMessage<Scheme>): Scheme {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.assets = [];
        message.assetPairExchangeRates = [];
        message.locales = [];
        message.walletAssets = [];
        message.walletProcessings = [];
        message.treeGroups = [];
        message.trees = [];
        if (value !== undefined)
            reflectionMergePartial<Scheme>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Scheme): Scheme {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated mlmbox.types.Asset assets */ 1:
                    message.assets.push(Asset.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated mlmbox.types.Exchanger.Rate asset_pair_exchange_rates */ 2:
                    message.assetPairExchangeRates.push(Exchanger_Rate.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated mlmbox.types.Locale locales */ 3:
                    message.locales.push(Locale.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated mlmbox.types.Wallet.Asset wallet_assets */ 4:
                    message.walletAssets.push(Wallet_Asset.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated mlmbox.types.Wallet.Processing wallet_processings */ 5:
                    message.walletProcessings.push(Wallet_Processing.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated mlmbox.types.Tree.Group tree_groups */ 6:
                    message.treeGroups.push(Tree_Group.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated mlmbox.types.Tree trees */ 7:
                    message.trees.push(Tree.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* mlmbox.types.Pool.Hunter pool_hunter */ 8:
                    message.poolHunter = Pool_Hunter.internalBinaryRead(reader, reader.uint32(), options, message.poolHunter);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Scheme, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated mlmbox.types.Asset assets = 1; */
        for (let i = 0; i < message.assets.length; i++)
            Asset.internalBinaryWrite(message.assets[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated mlmbox.types.Exchanger.Rate asset_pair_exchange_rates = 2; */
        for (let i = 0; i < message.assetPairExchangeRates.length; i++)
            Exchanger_Rate.internalBinaryWrite(message.assetPairExchangeRates[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated mlmbox.types.Locale locales = 3; */
        for (let i = 0; i < message.locales.length; i++)
            Locale.internalBinaryWrite(message.locales[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated mlmbox.types.Wallet.Asset wallet_assets = 4; */
        for (let i = 0; i < message.walletAssets.length; i++)
            Wallet_Asset.internalBinaryWrite(message.walletAssets[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated mlmbox.types.Wallet.Processing wallet_processings = 5; */
        for (let i = 0; i < message.walletProcessings.length; i++)
            Wallet_Processing.internalBinaryWrite(message.walletProcessings[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated mlmbox.types.Tree.Group tree_groups = 6; */
        for (let i = 0; i < message.treeGroups.length; i++)
            Tree_Group.internalBinaryWrite(message.treeGroups[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated mlmbox.types.Tree trees = 7; */
        for (let i = 0; i < message.trees.length; i++)
            Tree.internalBinaryWrite(message.trees[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* mlmbox.types.Pool.Hunter pool_hunter = 8; */
        if (message.poolHunter)
            Pool_Hunter.internalBinaryWrite(message.poolHunter, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Scheme
 */
export const Scheme = new Scheme$Type();
